export default "__VITE_ASSET__x1xWKaIL__"